// Base rows for a matrix field: row labels, padded with blank rows when
// "hide row labels" is on and a starting-row count (initial_rows) is set.
export const matrixBaseRows = (field) => {
  const labels = Array.isArray(field?.rowLabels) ? field.rowLabels : [];
  const wanted = field?.hide_row_labels ? (parseInt(field?.initial_rows, 10) || 0) : 0;
  const n = Math.max(labels.length, wanted);
  return Array.from({ length: n }, (_, i) => labels[i] || '');
};

// Template-defined prefill for a cell: field.columnDefaults[colIdx] is a
// multiline string; line N prefills base row N. Applies only until the
// clinician edits the cell (any stored value, including '', wins).
export const matrixCellDefault = (field, rowIdx, colIdx) => {
  if (rowIdx >= matrixBaseRows(field).length) return ''; // prefill applies to base rows only
  const col = field?.columnDefaults?.[colIdx];
  if (!col) return '';
  const lines = String(col).split('\n');
  return lines[rowIdx] !== undefined ? lines[rowIdx] : '';
};

export const matrixCellValue = (field, matrixData, rowIdx, colIdx) => {
  const v = matrixData?.[`${rowIdx}-${colIdx}`];
  return v === undefined ? matrixCellDefault(field, rowIdx, colIdx) : v;
};
